<!-- Banners globales — solo cuando hay sesión activa (no en login/sign-out) -->
@if (isAuthenticated) {
    <!-- Impersonation banner (super_admin viendo como otro usuario) -->
    <impersonation-banner></impersonation-banner>
    <!-- Connection status banner -->
    <community-conn-banner></community-conn-banner>
}
<router-outlet></router-outlet>
<toast></toast>
